import { secondAxios } from "../../api/axios";

export const authApi = {
  msLogin: ({ msToken }) =>
    secondAxios.post(
      "/auth/ms-login",
      {},
      {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${msToken}`,
        },
      }
    ),

  appLogin: (credentials) =>
    secondAxios.post("/auth/app-login", credentials, { withCredentials: true }),

  logout: () => secondAxios.post("/auth/logout"),

  refresh: () =>
    secondAxios.post("/auth/refresh", {}, { withCredentials: true }),

  getMyData: () => secondAxios.get("/auth/me"),
};
